import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import FormPage from "./pages/FormPage";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminForgotPassword from "./pages/admin/AdminForgotPassword";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import AdminDashboard from "./pages/admin/AdminDashboard";
import SubmissionDetail from "./pages/admin/SubmissionDetail";
import RatesEditor from "./pages/admin/RatesEditor";
import ApeRequests from "./pages/admin/ApeRequests";
import UserAuth from "./pages/user/UserAuth";
import UserForgotPassword from "./pages/user/UserForgotPassword";
import UserResetPassword from "./pages/user/UserResetPassword";
import UserDashboard from "./pages/user/UserDashboard";
import UserPracticeDetail from "./pages/user/UserPracticeDetail";
import AgenziaAuth from "./pages/agenzia/AgenziaAuth";
import AgenziaDashboard from "./pages/agenzia/AgenziaDashboard";
import PublicSignaturePage from "./pages/PublicSignaturePage";

function RequireAuth({ children }) {
  const token = localStorage.getItem("cc_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function RequireUserAuth({ children }) {
  const token = localStorage.getItem("cc_user_token");
  if (!token) return <Navigate to="/utente/login" replace />;
  return children;
}

function RequireAgenziaAuth({ children }) {
  const token = localStorage.getItem("cc_user_token");
  if (!token) return <Navigate to="/agenzia/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/attestazione" element={<FormPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/password-dimenticata" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/submissions/:id"
            element={
              <RequireAuth>
                <SubmissionDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/rates"
            element={
              <RequireAuth>
                <RatesEditor />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/ape-requests"
            element={
              <RequireAuth>
                <ApeRequests />
              </RequireAuth>
            }
          />
          {/* User (locatore) panel */}
          <Route path="/utente/login" element={<UserAuth mode="login" />} />
          <Route path="/utente/register" element={<UserAuth mode="register" />} />
          <Route path="/utente/password-dimenticata" element={<UserForgotPassword />} />
          <Route path="/utente/reset-password/:token" element={<UserResetPassword />} />
          <Route path="/utente" element={<RequireUserAuth><UserDashboard /></RequireUserAuth>} />
          <Route path="/utente/pratica/:id" element={<RequireUserAuth><UserPracticeDetail /></RequireUserAuth>} />
          {/* Agency panel */}
          <Route path="/agenzia/login" element={<AgenziaAuth mode="login" />} />
          <Route path="/agenzia/register" element={<AgenziaAuth mode="register" />} />
          <Route path="/agenzia/dashboard" element={<RequireAgenziaAuth><AgenziaDashboard /></RequireAgenziaAuth>} />
          <Route path="/agenzia/pratica/:id" element={<RequireAgenziaAuth><UserPracticeDetail /></RequireAgenziaAuth>} />
          <Route path="/firma/:token" element={<PublicSignaturePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
